<ca-table
    [ngClass]="{
        'my-files': myFilesClass,
        'my-files-header': !stickyHeader,
        'MED-create-and-start-dialog-right-split': isMEDProjectEnabled && totalNumberOfFiles,
        'MED-create-and-start-dialog-right-split-no-files': isMEDProjectEnabled && totalNumberOfFiles === 0,
        'arivis-cloud-create-and-start-dialog-right-split': !isMEDProjectEnabled && totalNumberOfFiles,
        'remove-overflow-y-axis': !totalNumberOfFiles && !isFileExplorerShown,
        'no-files-shown-unset-height': !totalNumberOfFiles,
        'table-position-retry': isCZIConversionInProgress && !isAddedFilesVisible && !isConversionFailedVisible && !isInvalidFilesVisibile,
        'table-poisiton-shift-no-added-files': !isAddedFilesVisible && isConversionFailedVisible && isInvalidFilesVisibile,
        'table-poisiton-shift': isConversionFailedVisible && isInvalidFilesVisibile && isAddedFilesVisible,
        'table-poisiton-shift-invalid': !isConversionFailedVisible && isInvalidFilesVisibile && isAddedFilesVisible,
        'table-poisiton-shift-conversion-failed': isConversionFailedVisible && !isInvalidFilesVisibile && isAddedFilesVisible,
        'table-position-only-invalid-files': !isAddedFilesVisible && !isConversionFailedVisible && isInvalidFilesVisibile,
        'table-static-position': totalNumberOfFiles && !isCZIConversionInProgress && !isInvalidFilesVisibile && !isConversionFailedVisible,
        'table-position-shift-no-invalid-files': isCZIConversionInProgress,
    }"
    data-uit="files-table"
    class="mb-2"
>
    <thead [ngClass]="isMEDProjectEnabled && !isFilesPage ? 'MED-start-and-upload-dialog-bg' : ''" *ngIf="showTableHead && !isEmptyAndModificationMode()">
        <tr>
            <th *ngIf="isCheckboxIncluded() && mode === FILE_EXPLORER_MODE.MODIFICATION" class="col-checkbox pe-0 ps-0">
                <span>
                    <ca-input-checkbox
                        [style.visibility]="isEmptyAndModificationMode() ? 'hidden' : 'visible'"
                        data-uit="select-all-checkbox"
                        [checked]="areAllFilesSelected"
                        (change)="onSelectAllRowsChange()"
                    ></ca-input-checkbox>
                </span>
            </th>
            <th *ngIf="isFileStatusIncluded() && isCziConversionEnabled" class="col-checkbox"></th>
            <th class="col-name">
                <span>
                    <div *ngIf="mode === FILE_EXPLORER_MODE.SELECTION || !areSomeRowsSelected" class="d-flex flex-row align-items-center">
                        <span class="me-2 white-space-no-wrap without-border">{{ 'GENERAL.COLUMN.NAME' | translate }}</span>
                        <button
                            *ngIf="isAddAllFilesClickButtonShown && totalNumberOfFiles > 0 && !isFilesPage"
                            type="button"
                            class="btn btn-secondary btn-sm"
                            (click)="addAllFilesClick.emit()"
                            [ngbTooltip]="addAllFilesButtonTooltip"
                            container="body"
                            data-uit="select-all-files-from-current-folder-btn"
                        >
                            {{
                                (totalNumberOfFiles === 1 ? 'GENERAL.SELECT_FILE' : 'GENERAL.SELECT_ALL_FILES')
                                    | translate: { numberOfFiles: totalNumberOfFiles }
                            }}
                        </button>
                    </div>
                    <div *ngIf="mode === FILE_EXPLORER_MODE.MODIFICATION && areSomeRowsSelected" class="d-flex flex-row align-items-center">
                        <span class="white-space-no-wrap no-underline">{{ tableBannerText }}</span>
                        <div class="d-flex flex-row" data-uit="files-table-action-container">
                            <button
                                *ngIf="actions.includes('view') && isAtLeastOneArivisPreviewableFileSelected()"
                                type="button"
                                class="btn ca-btn-icon ms-2"
                                (click)="openSelectedFilesInArivis()"
                                data-uit="file-preview-btn"
                                [ngbTooltip]="'GENERAL.PREVIEW' | translate"
                                placement="auto"
                            >
                                <ca-icon name="eye-open" size="s"></ca-icon>
                            </button>
                            <button
                                *ngIf="actions.includes('delete')"
                                type="button"
                                class="btn ca-btn-icon ms-2"
                                (click)="deleteItems.emit({ items: selectedFilesAndFolders, shouldConfirmDialogBeOpened: true })"
                                data-uit="files-bulk-delete"
                                [ngbTooltip]="'FILES_TABLE.DELETE_SELECTED_FILES' | translate"
                                placement="auto"
                            >
                                <ca-icon name="trash" size="s"></ca-icon>
                            </button>
                            <button
                                *ngIf="actions.includes('remove')"
                                type="button"
                                class="btn ca-btn-icon ms-2"
                                (click)="removeItems.emit({ items: selectedFilesAndFolders, shouldConfirmDialogBeOpened: true })"
                                data-uit="files-bulk-remove"
                                [title]="'FILES_TABLE.REMOVE_SELECTED_FILES' | translate"
                                [ngbTooltip]="'FILES_TABLE.REMOVE_SELECTED_FILES' | translate"
                            >
                                <ca-icon name="cross" size="s"></ca-icon>
                            </button>
                            <div class="d-flex flex-row" data-uit="files-table-action-container-med">
                                <button
                                    *ngIf="actions?.includes('editResearchStudyID')"
                                    type="button"
                                    class="btn ca-btn-icon ms-2"
                                    (click)="editResearchStudyID(tableBannerText)"
                                    data-uit="files-bulk-edit"
                                    [ngbTooltip]="'FILES_TABLE.MED.EDIT_RESEARCH_ID' | translate"
                                    placement="auto"
                                >
                                    <ca-icon name="pen" size="m"></ca-icon>
                                </button>
                                <button
                                    *ngIf="actions?.includes('editTag')"
                                    type="button"
                                    class="btn ca-btn-icon ms-2"
                                    (click)="addTags(tableBannerText)"
                                    data-uit="files-bulk-add"
                                    [ngbTooltip]="'FILES_TABLE.MED.ADD_TAGS' | translate"
                                >
                                    <ca-icon name="edit-tag" size="l"></ca-icon>
                                </button>
                            </div>
                            <ca-file-download-btn
                                class="ms-2"
                                *ngIf="actions.includes('download') && isDownloadMultipleFilesBtnShown()"
                                (onClick)="downloadSelectedFiles()"
                                [title]="'FILES_TABLE.DOWNLOAD_SELECTED_FILES' | translate"
                                placement="auto"
                            ></ca-file-download-btn>
                        </div>
                    </div>
                </span>
            </th>
            <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.translationKey">
                    <th>
                        <span class="th-col-size">
                            {{ column.translationKey | translate }}
                        </span>
                    </th>
                </ng-container>
            </ng-container>
        </tr>
    </thead>
    <tbody
        id="files-table-body"
        caApeerFileUpload
        [uploadValidationSelectedFiles]="allFiles"
        [allowSameFileNames]="allowSameFileNames"
        [blobType]="blobType"
        [uploaderKey]="uploaderKey"
        [targetFolderId]="folderId"
        [createTargetFolder]="targetFolderToBeCreated"
        [cancelUpload]="cancelUpload"
        [cancelAllUploads]="cancelAllUploads"
        [supportedFileTypes]="supportedFileTypes"
        [errorNotificationMode]="isFilesPage ? 'none' : 'confirmation'"
        [datasetId]="datasetId"
        [datasetFileType]="datasetFileType"
        [ngClass]="{ 'empty-body': isEmptyAndModificationMode() }"
        [allowDragAndDropUpload]="!isMEDProjectEnabled"
        (targetFolderCreated)="targetFolderCreated.emit($event)"
        (onAllUploadsCompleted)="uploadCompleted()"
        (onFilesAdded)="filesAdded($event)"
        (onUploadCompleted)="onUploadCompleted.emit($event)"
        (onUploadCancelled)="uploadCancelled()"
        data-uit="files-table-body"
    >
        <tr *ngIf="!totalNumberOfFiles && isFileExplorerShown" class="placeholder-height-modifier"></tr>
        <tr
            *ngIf="(isEmptyAndModificationMode() && !isMEDProjectEnabled) || (isEmptyAndModificationMode() && isUploadOfFilesEnabled)"
            class="upload-row drop-zone"
            attr.data-rowIsFolder="false"
            attr.data-targetFolderId="{{ folderId }}"
        >
            <td colspan="6">
                <div class="d-flex flex-column align-items-center">
                    <ca-icon name="upload" size="m" [title]="'MY_WORKSPACE.MY_FILES.UPLOAD_FILES' | translate"></ca-icon>
                    <span class="font-m border-bottom-0">{{ 'WORKFLOWS.RUNNER.DRAG_AND_DROP_INPUT_FILES' | translate }}</span>
                </div>
            </td>
        </tr>
        <tr *ngIf="isEmptyAndModificationMode() && !isUploadOfFilesEnabled && isMEDProjectEnabled" class="upload-row MED-no-drop-zone">
            <td colspan="6">
                <div class="d-flex flex-column align-items-center">
                    {{ isSelectedFilesShown ? ('FILES_TABLE.MED.SELECTED_FILES' | translate) : ('FILES_TABLE.MED.UPLOADED_FILES' | translate) }}
                </div>
            </td>
        </tr>
        <tr
            *ngFor="let row of rows; let first = first; let index = index"
            class="group-child-row"
            [ngClass]="{
                selected: mode === FILE_EXPLORER_MODE.MODIFICATION && row.selected,
                selection: mode === FILE_EXPLORER_MODE.SELECTION,
                'group-child-row-first-in-group': first,
                'is-submenu-open': fileItemSubMenuOpenIndex === index || folderItemSubMenuOpenIndex === index,
                'text-danger': row.isConvertedAndHasInvalidValidationStatus,
            }"
            [ngClass]="{ 'text-danger': row.isConvertedAndHasInvalidValidationStatus }"
            (click)="handleRowClick(row, $event)"
            data-uit="files-table-file-row"
            attr.data-rowIsFolder="{{ row.isFolder }}"
            attr.data-targetFolderId="{{ row.isFolder ? row.item.id : folderId }}"
            attr.data-rowId="{{ row.item.id }}"
            [attr.draggable]="mode === FILE_EXPLORER_MODE.MODIFICATION"
            ondragover="event.preventDefault()"
            #trRef
        >
            <td *ngIf="isCheckboxIncluded() && mode === FILE_EXPLORER_MODE.MODIFICATION" class="me-0 pe-0 ps-0">
                <span class="me-0">
                    <ca-input-checkbox
                        data-uit="file-selected"
                        [ngClass]="{ checked: row.selected }"
                        [checked]="row.selected"
                        (change)="onRowCheckboxChange(row)"
                        (click)="$event.stopPropagation()"
                    ></ca-input-checkbox>
                </span>
            </td>
            <td *ngIf="isFileStatusIncluded()" class="ps-0 d-flex align-items-center justify-content-center">
                <ca-file-status-icon
                    [convertStatus]="isCziConversionEnabled ? row.item.convertStatus : 'Success'"
                    [validationStatus]="row.item.validationStatus"
                    [shouldShowValidationStatus]="!!datasetId"
                    [isSegmentation]="isSegmentation"
                ></ca-file-status-icon>
            </td>
            <td class="ps-0" class="truncation-wrapper">
                <span [caTruncate]="500" class="text-truncate ps-0">
                    <ca-file-actions
                        #parent
                        [index]="index"
                        [isFolder]="row.isFolder"
                        [isSelected]="row.selected"
                        [mode]="mode"
                        [isSegmentation]="isSegmentation"
                        [isFilesStatusShown]="isFilesStatusShown"
                        [item]="row.item"
                        [truncateFileNameAtWidthOf]="500"
                        [datasetFolderType]="datasetFileType"
                        [datasetId]="datasetId"
                        [actions]="actions"
                        [showFileStatus]="showFileStatus && !isFileStatusIncluded()"
                        (onOpenFolder)="onOpenFolder.emit($event)"
                        (renameFolder)="renameFolder.emit($event)"
                        (deleteItems)="deleteItems.emit($event)"
                        (removeItems)="removeItems.emit($event)"
                        class="w-100"
                    >
                        <ca-file-item-submenu
                            *ngIf="mode === FILE_EXPLORER_MODE.MODIFICATION && !parent.isFolder && parent.item.convertStatus !== 'Active'"
                            data-uit="file-item-submenu"
                            [ngClass]="{ checked: parent.isSelected, isFolder: parent.isFolder }"
                            [fileModel]="parent.item"
                            [isPreviewBtnEnabled]="isPreviewBtnEnabled(parent.item)"
                            [isRenameBtnEnabled]="isRenameBtnEnabled()"
                            [isDownloadBtnEnabled]="isDownloadBtnEnabled()"
                            [isDeleteBtnEnabled]="isDeleteBtnEnabled()"
                            [isRemoveBtnEnabled]="isRemoveBtnEnabled()"
                            [isShareBtnEnabled]="isShareBtnEnabled(parent.item)"
                            [datasetId]="datasetId"
                            [isDownloadAnnotationsTrackingEventEnabled]="isDownloadAnnotationsTrackingEventEnabled"
                            [shareUrl]="parent.item.shareUrl"
                            (previewFile)="parent.openFile($event)"
                            (deleteItems)="deleteItems.emit($event)"
                            (removeItems)="removeItems.emit($event)"
                            (openChange)="onFileItemSubMenuOpen(index, $event)"
                        ></ca-file-item-submenu>
                        <ca-folder-item-submenu
                            *ngIf="mode === FILE_EXPLORER_MODE.MODIFICATION && parent.isFolder"
                            data-uit="folder-item-submenu"
                            [ngClass]="{ checked: parent.isSelected, isFolder: parent.isFolder }"
                            [fileModel]="parent.item"
                            [isRenameBtnEnabled]="isRenameBtnEnabled()"
                            [isDeleteBtnEnabled]="isDeleteBtnEnabled()"
                            (renameFolder)="renameFolder.emit($event)"
                            (deleteItems)="deleteItems.emit($event)"
                            (openChange)="onFolderItemSubMenuOpen(index, $event)"
                        ></ca-folder-item-submenu>
                    </ca-file-actions>
                </span>
            </td>
            <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.defaultValue">
                    <td
                        [ngClass]="{
                            'text-danger':
                                isFilesStatusShown &&
                                row.item.validationStatus !== 'PendingValidation' &&
                                row.item.convertStatus !== 'Active' &&
                                row.item.validationStatus !== undefined
                                    ? (row.item.convertStatus === 'Success' && row.item.validationStatus !== 'Valid') ||
                                      row.item.convertStatus === 'Failed' ||
                                      row.item.convertStatus === 'NotCZI' ||
                                      (row.item.convertStatus === 'Success' && row.item.validationStatus === 'Unknown')
                                    : false,
                        }"
                    >
                        <ng-container *ngIf="column.key === 'customTags'; else otherContent">
                            <span class="px-0">
                                <ca-process-and-display-custom-tags
                                    *ngIf="!row.isFolder"
                                    class="custom-tags d-flex align-items-center"
                                    [tags]="row.item?.metadata[column.key]"
                                    [isFilesPage]="isFilesPage"
                                    [titleKey]="'customTags'"
                                    [placeholder]="'FILES_TABLE.MED.ADD_TAGS' | translate"
                                    (closeTag)="onTagRemove(row, $event)"
                                    (createTag)="onCreateCustomTag(row, $event)"
                                    (click)="$event.stopPropagation()"
                                ></ca-process-and-display-custom-tags>
                            </span>
                        </ng-container>
                        <ng-template #otherContent [ngSwitch]="column.transform">
                            <ng-container *ngIf="column.key !== 'editStudyID'">
                                <ng-container *ngIf="row.isFolder">
                                    <span *ngSwitchCase="'fileSize'">{{ column.defaultValue }}</span>
                                </ng-container>
                                <ng-container *ngIf="!row.isFolder">
                                    <span *ngSwitchCase="'fileSize'">{{ (row.item?.[column.key] | fileSize) || column.defaultValue }}</span>
                                </ng-container>
                                <span *ngSwitchCase="'titlecase'">{{
                                    (row.item?.[column.key] | titlecase) || (row.item?.metadata?.[column.key] | titlecase) || column.defaultValue
                                }}</span>
                                <span *ngSwitchCase="'resultDate'" data-uit="file-created-at">{{
                                    (row.item[column.key] | resultDate: column.transformDateFormat : column.transformTimeFormat) ||
                                        (row.item?.metadata?.[column.key] | resultDate: column.transformDateFormat : column.transformTimeFormat) ||
                                        column.defaultValue
                                }}</span>
                                <span *ngSwitchCase="'lowercase'">{{ (row.item?.[column.key] | lowercase) || column.defaultValue }}</span>
                                <ng-container *ngSwitchDefault>
                                    <span *ngIf="!row.isFolder">
                                        {{ row.item?.[column.key] || row.item?.metadata?.[column.key] || column.defaultValue }}
                                    </span>
                                    <span *ngIf="row.isFolder">
                                        {{ row.item?.[column.key] || column.defaultValue }}
                                    </span>
                                </ng-container>
                            </ng-container>
                            <span class="px-0 study-research-id-field" *ngIf="column.key === 'editStudyID'">
                                <ca-process-and-display-study-id
                                    class="custom-tags d-flex align-items-center"
                                    [studyId]="row.item?.metadata[column.key]"
                                    [titleKey]="'studyId'"
                                    [isFilesPage]="isFilesPage"
                                    [studyIdValue]="row.item?.metadata.studyId"
                                    [placeholder]="'FILES_TABLE.MED.ENTER_RESEARCH_ID' | translate"
                                    (createStudyId)="onCreateStudyId(row, $event)"
                                    (click)="$event.stopPropagation()"
                                ></ca-process-and-display-study-id>
                            </span>
                        </ng-template>
                    </td>
                </ng-container>
            </ng-container>
        </tr>
        <!--This is empty placeholder row used when there are only folders in the current folder in order to be able to upload files by dropping to the current folder tbody-->
        <ng-container *ngIf="showEmptyRows && rows?.length > 0 && rows?.length < 10">
            <tr
                *ngFor="let i of Array.from(Array(10 - rows.length).keys())"
                class="upload-row placeholder-file-row"
                attr.data-rowIsFolder="false"
                attr.data-targetFolderId="{{ folderId }}"
            >
                <td colspan="6"></td>
            </tr>
        </ng-container>
    </tbody>
</ca-table>
